import {
  AspectRatio,
  Card,
  Container,
  Image,
  SimpleGrid,
  Text,
  Title,
  Button,
  Group,
  Breadcrumbs,
  Anchor,
} from "@mantine/core";
import {
  IconCalendar,
  IconUser,
  IconTag,
  IconChevronLeft,
} from "@tabler/icons";
import classes from "../styles/ArticlesCards.module.css";
import METATAGSEO from "@/components/metaTagSEO";
import JsonLd from "@/components/JsonLd";
import Link from "next/link";
import { siteConfig } from "@/components/seoConfig";

// מאמרים ממוקדי מילות מפתח בהתבסס על נתוני Search Console
const blogArticles = [
  {
    id: 1,
    title:
      "למה גוגל קלנדר לא מותאם לעסק שלך? QuickTor - פתרון ניהול תורים מקצועי",
    description:
      "למה לאבד כסף על ביטולי תורים? QuickTor שמה סוף להברזות, שולחת תזכורות וואטסאפ ומציעה  לאפשר תשלום מראש על תורים - כל הסיבות למה לעבור מגוגל קלנדר !",
    image: "/quicktorVSgoogle_calendar.webp",
    altText:
      "אישה בתמונה שמקבלת הודעה בטלפון דרך מערכת ניהול תורים באמצעות וואטסאפ, תוכן הודעת התזכורת מוצג גם כן ליד האישה",
    date: "04 מאי, 2025",
    author: "צוות QuickTor",
    tags: ["וואטסאפ", "תזכורות", "אוטומציה"],
    slug: "quicktor-vs-google-calendar",
    keywords: [
      "ניהול תורים עסקי",
      "גוגל קלנדר לעסקים",
      "תזכורות וואטסאפ לתורים",
      "הפחתת ביטולי תורים",
      "רשימת המתנה חכמה",
      "תשלום מראש לתורים",
    ],
  },
  {
    id: 2,
    title: "ניהול תורים דיגיטלי: המדריך המקיף שעושה סוף לחורים ביומן ב-2025",
    description:
      "כיצד ניהול יומן תורים יעיל יכול להגדיל את הרווחיות של העסק שלך ב-30% ולשפר את חווית הלקוחות",
    image: "/queue_management.webp",
    altText:
      "סלון מספרה ובו הספר מתעסק בעבודה בזמן שרואים שהיומן מתמלא לבד על ידי מערכת ניהול תורים",
    date: "13 במרץ, 2025",
    author: "צוות QuickTor",
    tags: ["יומן תורים", "ניהול עסק", "חווית לקוח"],
    slug: "appointment-scheduling-guide",
    keywords: [
      "יומן לקוחות",
      "יומן תורים",
      "ניהול יומן עסקי",
      "אפליקציה לניהול תורים",
    ],
  },
  {
    id: 3,
    title: "איך לשפר את אחוזי ההגעות לפגישות בעזרת מערכת תזכורות",
    description:
      "לקוחות לא מגיעים לתורים? בעלי מספרות וסלוני יופי מאבדים עד 25% מהתורים. גלו איך מערכת QuickTor פותרת את הבעיה בקלות ומגדילה את ההכנסה החודשית ב-10-20%.",
    SubDescription:
      "המדריך המקיף לשיפור אחוזי ההתייצבות באמצעות תזכורות אוטומטיות ואסטרטגיות מוכחות",
    image: "/magazine_reminders.webp",
    altText:
      "מערכת תזכורות אוטומטיות לעסקים שבה ניתן לראות שני דמויות שמציגים איך היומן מתמלא אוטומטית",
    date: "19 במרץ, 2025",
    author: "צוות QuickTor",
    tags: ["תזכורות אוטומטיות", "ניהול פגישות", "אישור הגעה", "וואטסאפ"],
    slug: "improve-appointment-show-rates-with-reminders",
    keywords: [
      "מערכת תזכורות",
      "הפחתת אי-התייצבות",
      "תזכורות אוטומטיות לפגישות",
      "שיפור התייצבות לקוחות",
      "ניהול תורים אפקטיבי",
      "SMS תזכורות",
      "WhatsApp תזכורות",
    ],
  },
  {
    id: 4,
    title: "איך לנהל תורים באמצעות וואטסאפ: המדריך השלם",
    description:
      "הדרכה מעשית לשילוב וואטסאפ במערכת ניהול התורים שלך, כולל תזכורות אוטומטיות ואישורי הגעה",
    image: "/magazine_whatsapp_.webp",
    altText:
      "אישה בתמונה שמקבלת הודעה בטלפון דרך מערכת ניהול תורים באמצעות וואטסאפ, תוכן הודעת התזכורת מוצג גם כן ליד האישה",
    date: "10 במרץ, 2025",
    author: "צוות QuickTor",
    tags: ["וואטסאפ", "תזכורות", "אוטומציה"],
    slug: "whatsapp-appointment-management",
    keywords: ["ניהול תורים וואטסאפ", "תזכורות לתורים", "ניהול לקוחות אונליין"],
  },
  {
    id: 5,
    title: "מדריך: העברת הלקוחות למערכת ניהול תורים תוך 30 שניות | QuickTor",
    description: "גלו איך QuickTor חוסך שעות עבודה בהעברת לקוחות למערכת תורים חדשה. אוטומציה חכמה שמבטיחה מעבר חלק ללא איבוד לקוחות. מדריך מלא לבעלי עסקים ✓",
    SubDescription: "מרגישים שמעבר הלקוחות למערכת ניהול תורים מוריד לכם את החשק להתחיל תהליך כזה בגלל הזמן שזה דורש? איתנו לא צריך להיות לכם החשש, אנחנו נדאג לכאב ראש הזה ונלווה אתכם בכל צעד על ידי הכלים המתקדמים שלנו",
    image: "/get-all-customers-to-app.webp",
    OgImageUrl: "/quicktor-automation-transfer.webp",
    ogType: "article",
    altText: "העברת לקוחות אוטומטית למערכת QuickTor - מעבר דיגיטלי ללא כאב ראש",
    date: "26 יוני, 2025",
    author: "רודה דין",
    canonicalUrl: `https://quicktor.co.il/blog/quicktor-automation-transfer`,
    tags: ["אוטומציה חכמה", "העברת לקוחות", "מעבר דיגיטלי", "ניהול תורים", "חיסכון עלויות"],
    slug: "quicktor-automation-transfer",
    keywords: [
      "העברת לקוחות אוטומטית",
      "מעבר למערכת תורים דיגיטלית",
      "אוטומציה QuickTor",
      "חיסכון עלויות מעבר דיגיטלי",
      "ניהול תורים אוטומטי",
      "מעבר ללא איבוד לקוחות",
      "שיפור יעילות עסקית",
      "טכנולוגיה לעסקים קטנים"
    ],
  },
  {
    id: 6,
    title: "מדריך: 5 שלבים להכנסות גבוהות ואפס הברזות - QuickTor",
    description: "גלו איך תשלום מראש דרך אפליקציה מונע 100% מההברזות, חוסך 15 שעות עבודה שבועיות ומגדיל רווחים ב-40%. מדריך מעשי לבעלי עסקים ✅ תוצאות מוכחות ✅ יישום מיידי",
    SubDescription: "למה לאבד כסף על ביטולי תורים? גלו איך תשלום מראש חובה מחולל מהפכה בעסקים ומונע הברזות ב-100%. המדריך המלא לניהול עומסים חכם עם תוצאות מוכחות 👇",
    image: "/get-payment-online.webp",
    OgImageUrl: "/get-payment-online.webp",
    ogType: "article",
    altText: "ניהול עומסים ולקוחות בעסק - תשלום מראש למניעת הברזות",
    date: "26 יוני, 2025",
    author: "רודה דין",
    canonicalUrl: `https://quicktor.co.il/blog/5-steps-high-profits-zero-cancellations`,
    tags: ["ניהול עומסים", "תשלום מראש", "מניעת הברזות", "ניהול לקוחות", "רווחיות עסקית"],
    slug: "5-steps-high-profits-zero-cancellations",
    keywords: [
      "ניהול עומסים בעסק",
      "מניעת הברזות תורים",
      "תשלום מראש לתורים",
      "ניהול לקוחות יעיל",
      "הגדלת רווחיות עסק",
      "אפליקציה ניהול תורים",
      "חיסכון זמן בעסק",
      "תזרים מזומנים משופר"
    ],
  },

  {
    id: 8,
    title: "ניהול תורים לנייליסטיות: המדריך המקיף לניהול עסק נייל ב-2026",
    description: "נייליסטיות מפסידות 28,000₪ בשנה על הברזות. גלי איך מערכת ניהול תורים חכמה עם תזכורות ווטסאפ ותשלום מראש מפחיתה הברזות ב-95%. מדריך מלא לנייליסטיות ✓",
    SubDescription: "ניהול תורים לנייל שונה מכל עסק אחר — שירותים ארוכים, לקוחות חוזרות כל חודש ותורים שמתנגשים. גלי מה המערכת הנכונה שתחסוך לך שעות ותמנע הברזות לתמיד.",
    image: "/nail_appointment.webp",
    altText: "מערכת ניהול תורים לנייליסטיות בישראל - יומן חכם עם תזכורות ווטסאפ אוטומטיות",
    date: "19 במאי, 2026",
    author: "צוות QuickTor",
    tags: ["נייליסטיות", "ניהול תורים", "תזכורות ווטסאפ", "תשלום מראש", "עסק נייל"],
    slug: "nail-appointment-management",
    keywords: [
      "ניהול תורים לנייליסטיות",
      "מערכת תורים לנייל",
      "יומן לנייליסטית",
      "תזכורות ווטסאפ לנייל",
      "מניעת הברזות נייל",
      "תשלום מראש נייליסטית",
      "אפליקציה לניהול תורים נייל",
      "ניהול עסק נייל",
    ],
  },
  {
    id: 9,
    title: "תשלומים ומקדמות בוואטסאפ: שריון תורים אוטומטי לעסקים | QuickTor",
    description: "המדריך המלא לגביית תשלומים ומקדמות ישירות בוואטסאפ. גלו איך לקוחות יכולים לשריין תור ולשלם באופן אוטומטי. חסכו זמן והגדילו רווחים עם אוטומציה.",
    SubDescription: "איך לגבות תשלומים ומקדמות בוואטסאפ? המדריך המלא לשריון תורים אוטומטי שחוסך זמן ומקטין ביטולים למינימום.",
    image: "/whatsapp_payment_request.webp",
    OgImageUrl: "/whatsapp_payment_request.webp",
    ogType: "article",
    altText: "תשלומים ומקדמות בוואטסאפ לשריון תורים",
    date: "24 במאי, 2026",
    author: "צוות QuickTor",
    canonicalUrl: `https://quicktor.co.il/blog/whatsapp-payments-booking`,
    tags: ["וואטסאפ", "מקדמות ותשלומים", "אוטומציה", "ניהול עסק", "ניהול תורים"],
    slug: "whatsapp-payments-booking",
    keywords: [
      "תשלומים בוואטסאפ",
      "מקדמה לתור",
      "שריון תור אוטומטי",
      "ניהול תורים בישראל",
      "קביעת תור אונליין",
      "מערכת ניהול תורים",
      "תשלום מראש וואטסאפ",
      "ביטולי תורים"
    ],
  }
];
// עבור המאמר הבא
//  title: "איך לחסוך 15 שעות עבודה בשבוע ולמנוע הברזות לתמיד - מדריך ניהול עומסים לבעלי עסקים 2026",

const ArticlesCards = () => {
  // Breadcrumbs for better navigation and SEO
  const items = [
    { title: "דף הבית", href: "/", redirect: true },
    { title: "מרכז מידע", href: "/magazine", redirect: false },
  ].map((item, index) => (
    <>
      {item.redirect ? (
        <Anchor component={Link} href={item.href} key={index}>
          {item.title}
        </Anchor>
      ) : (
        <Text>{item.title}</Text>
      )}
    </>
  ));


  const BreadcrumbListJson = [
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/`,
      name: "דף הבית",
      position: 1,
    },
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/magazine`,
      name: "מרכז מידע",
      position: 2,
    },
  ];

  // יצירת הכרטיסים עם מטא-דאטה משופר לקידום אורגני
  const cards = blogArticles.reverse().map((article) => (
    <Card
      key={article.id}
      p="lg"
      radius="md"
      component="a"
      href={`/blog/${article.slug}`}
      className={classes.card}
      withBorder
    >
      <AspectRatio ratio={1920 / 950}>
        <Image
          src={article.image}
          alt={article.altText}
          fit="fill"
          loading="lazy"
        />
      </AspectRatio>

      <Group mt="md" mb="xs">
        <Group gap="xs">
          <IconCalendar size={16} />
          <Text size="sm" c="dimmed">
            {article.date}
          </Text>
        </Group>
        <Group gap="xs">
          <IconUser size={16} />
          <Text size="sm" c="dimmed">
            {article.author}
          </Text>
        </Group>
      </Group>

      <Title order={2} className={classes.title} fw={700} size="lg" mt="xs">
        {article.title}
      </Title>

      <Text c="dimmed" size="sm" lineClamp={3} mt="xs">
        {article.description}
      </Text>

      <Group mt="md">
        {article.tags.map((tag) => (
          <Group key={tag} gap="xs">
            <IconTag size={16} />
            <Text size="xs" c="blue">
              {tag}
            </Text>
          </Group>
        ))}
      </Group>

      <Button variant="light" color="blue" fullWidth mt="md">
        קרא עוד
      </Button>
    </Card>
  ));

  const seoData = {
    title: "QuickTor | מרכז מידע ומגזין לניהול תורים – מאמרים וטיפים מקצועיים",
    description:
      "במרכז המידע שלנו תמצאו מאמרים מקצועיים, טיפים מעשיים ומדריכים עדכניים בתחום ניהול התורים. שפרו את תהליכי ניהול התורים בעסק שלכם עם ידע וכלים יעילים.",
    canonicalUrl: `${siteConfig.baseUrl}/magazine`,
    keywords:
      "מערכת ניהול תורים, יומן חכם, ניהול תורים, זימון תורים, יומן פגישות, תוכנה לניהול יומן, אפליקציה לניהול תורים",
    isPartOf: "https://quicktor.co.il/",
  };

  return (
    <Container py="xl">
      <Breadcrumbs separator={<IconChevronLeft size={14} />}>
        {items}
      </Breadcrumbs>
      <METATAGSEO {...seoData} />
      <JsonLd
        canonical={`https://quicktor.co.il/magazine`}
        title={
          "QuickTor | מרכז מידע ומגזין לניהול תורים – מאמרים וטיפים מקצועיים"
        }
        description={
          "במרכז המידע שלנו תמצאו מאמרים מקצועיים, טיפים מעשיים ומדריכים עדכניים בתחום ניהול התורים. שפרו את תהליכי ניהול התורים בעסק שלכם עם ידע וכלים יעילים."
        }
        OgImageUrl={"https://quicktor.co.il/magazine_whatsapp_.webp"}
        isPartOf={`https://quicktor.co.il/`}
        BreadcrumbListJson={BreadcrumbListJson}
      />
      <Title
        className={classes.noto_sans_hebrew}
        fw={500}
        order={1}
        style={{ fontFamily: "Rubik, Heebo, sans-serif" }}
        ta="center"
        mb="xl"
      >
        המדריכים שלנו לניהול תורים יעיל
      </Title>
      <Text c="dimmed" ta="center" mb="xl" maw={700} mx="auto">
        מאמרים מקצועיים וטיפים פרקטיים שיעזרו לך לנהל את היומן והתורים בעסק שלך
        ביעילות מרבית
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }}>{cards}</SimpleGrid>
    </Container>
  );
};

export default ArticlesCards;
